export default "__VITE_ASSET__af06602c__"